import { html, CSSResult, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import GmfBaseElement from 'gmfapi/elements/BaseElement';

import user, { User } from 'gmfapi/store/user';
import config, {Configuration} from 'gmfapi/store/config';
import AuthenticationService, { RouteSuffix } from "ngeo/auth/service";

import i18next from 'i18next';



@customElement('mapbs-auth-panel')
class MapbsAuthPanel extends GmfBaseElement {
  @state() private gmfUser: User = null;
  constructor() {
    super();
  }

  connectedCallback(): void {
    super.connectedCallback();
    this.subscriptions.push(
      user.getProperties().subscribe({
        next: (properties: User) => {
          this.gmfUser = properties;
        },
      })
    );
    config.getConfig().subscribe({
      next: (configuration: Configuration) => {
        if (configuration) {
          this.mapbsServiceUserKeycloak = configuration.mapbs_service_user_keycloak;
        }
      },
    })
 
  }

  static styles: CSSResult[] = [
    ...GmfBaseElement.styles,
    css`
    .btn.prime {
      background-color: #E4E4E4;
      border-radius: 0.25rem;
      border: none;
      color: #000000;
    }
    .btn.prime:hover {
      background-color: #E4E4E4;
    }
    .btn.prime:focus {
      box-shadow: none;
    }
    .btn {
        text-align: left;
        padding: 1rem;
    }`,
  ];

  render() {
    return html`
    ${this.gmfUser.username !== null && this.gmfUser.username !== this.mapbsServiceUserKeycloak ?
        html`
        <div class="form-group">
            <span>${i18next.t('Logged in as')}</span>
            <strong>${this.gmfUser.given_name} ${this.gmfUser.family_name}</strong>.

        </div>
        <form name="logoutForm" role="form" ng-submit="authCtrl.logout()">
          <div class="form-group">
              <input
                  class="form-control btn prime"
                  value="${i18next.t('Logout')}"
                  @click=${this.logout}
              />
          </div>
        </form>
        `
        : html`
        <form name="logoutForm" role="form">
          <div class="form-group">
              <input
                  class="form-control btn prime"
                  value="${i18next.t('Login')}"
                  @click=${this.login}
              />
          </div>
        </form>`}

    `;
  }

  logout() {
    console.log('logout');
    AuthenticationService.logout();
  }

  login() {
    console.log('login');
    AuthenticationService.login();
  }
}
